import React from 'react'
import { FormLabel } from 'hhsoig-design-system-core'
import { HorizontalField } from '../HorizontalField'

export class StandardHeightFields extends React.Component {
  static getDerivedStateFromProps(props) {
    let newState = {}
    if (Number.isInteger(props.field.value)) {
      newState = {
        feet: Math.floor(props.field.value / 12),
        inches: props.field.value % 12
      }
    }

    return Object.keys(newState).length > 0 ? newState : null
  }

  state = {
    feet: '',
    inches: ''
  }

  feetInput = null
  inchesInput = null
  feetRef = el => {
    this.feetInput = el
  }
  inchesRef = el => {
    this.inchesInput = el
  }

  _setFieldValue = () => {
    const newValue = this.feetInput.value * 12 + (this.inchesInput.value % 12)
    this.props.form.setFieldValue(this.props.field.name, newValue)
  }

  render() {
    const {
      errorMessage,
      hint,
      label,
      labelClassName,
      requirementLabel
    } = this.props

    return (
      <div className="ds-u-clearfix">
        <fieldset className="ds-u-padding--0 ds-u-border--0 ds-u-margin-top--3">
          <FormLabel
            component="legend"
            errorMessage={errorMessage}
            hint={hint}
            labelClassName={labelClassName}
            requirementLabel={requirementLabel}
          >
            {label}
          </FormLabel>
          <div className="ds-l-form-row">
            <div className="ds-l-col--auto">
              <HorizontalField
                label="feet"
                max={99}
                min={0}
                name="height__feet"
                onChange={this._setFieldValue}
                inputRef={this.feetRef}
                type="number"
                value={this.state.feet}
              />
            </div>
            <div className="ds-l-col--auto">
              <HorizontalField
                label="inches"
                max={11}
                min={0}
                name="height__inches"
                onChange={this._setFieldValue}
                inputRef={this.inchesRef}
                type="number"
                value={this.state.inches}
              />
            </div>
          </div>
        </fieldset>
      </div>
    )
  }
}
